import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import Home from '../views/Home.vue';
import Vr from '../views/VR.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Vr',
    component: Vr,
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

export default router;
